<template>
  <div class="nav">
    <a-card>
      <div v-for="(nav, index) in navBars" :key="index" class="nav-item">
        <a-divider v-if="nav.type === 'divider'"/>
        <a v-else @click="nextPage(nav.path), nav.name === 'ログアウト' ? showModalLogout() : ''" >{{nav.name}}</a>
        <span :class="'icon ' + nav.icon"></span>
      </div>
    </a-card>
    <!-- Popup logout -->
    <div>
      <a-modal ok-text="ログアウト" 
        cancel-text="キャンセル"
        :visible="visiblePopupLogout"
        @ok="handleOkLogout"
        @cancel="handleCancelLogout">
        <p>ログアウトしてよろしいでしょうか？</p>
      </a-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftMenuBar',
  props: {
    navBars: []
  },
  data() {
    return {
      visiblePopupLogout: false
    }
  },
  computed: {
  },
  methods: {
    showModalLogout() {
      this.visiblePopupLogout = true
    },
    nextPage(path) {
      this.$router.push(path)
    },
    handleOkLogout() {
      this.logout()
      this.visiblePopupLogout = false
    },
    handleCancelLogout() {
      this.visiblePopupLogout = false
    },
    logout() {
      // this.$auth.user = null
      // this.$auth.loggedIn = false
      // this.$router.push({path: '/'})
      this.$repositories('user').logout().then(
        (response) => {
          this.$auth.user = null
          this.$auth.loggedIn = false
          this.$router.push({path: '/'})
          console.log('response ', response)
        },
        (error) => {
          this.$toastr.error(error?.message)
        }
      )
    }
  },
  mounted() {
    if(this.$auth.loggedIn) {
      this.navBars.push({ type: 'divider' }, { path: '', name: 'ログアウト', icon: 'icon icon-bor-logout' })
    }
    if (this.navBars === null || this.navBars === '') {
      this.navBars =  [
        { path: '', name: 'マイページトップ' },
        { type: 'divider' },
        { path: '', name: '総保有ベネポ・ベネポ履歴' },
        { path: '', name: '獲得予定のベネポ', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: 'カフェテリアポイント' },
        { type: 'divider' },
        { path: '', name: '専用ポイント・補助クーポン' },
        { type: 'divider' },
        { path: '', name: 'マイクーポン' },
        { path: '', name: '過去のクーポン' },
        { type: 'divider' },
        { path: '', name: 'お申し込み履歴' },
        { path: '', name: '投稿したクチコミ' },
        { path: '', name: '給トク払いご利用履歴', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '閲覧履歴' },
        { type: 'divider' },
        { path: '', name: 'お気に入りメニュー' },
        { path: '', name: 'Wishリスト' },
        { type: 'divider' },
        { path: '', name: '会員プロフィール' },
        { path: '', name: 'メール受信・通知' },
        { path: '', name: 'クレジットカード', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '家族アカウント管理', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: 'ログアウト', icon: 'icon icon-bor-logout' }
      ]
    }
  }
}
</script>

<style lang="scss">
  @import './style.scss';
  .ant-card-body{
    @apply p-2;
  }
</style>